import home from "./img/bg-home.jpg";
import maintenance from "./img/cookie-the-pom-gySMaocSdqs-unsplash.jpg";
import ocamping from "./img/bg-tent.jpg";
import hapicolibri from "./img/hapicolibri.jpg";
import logo from "./img/logo.png";
import logodigihapi from "./img/logoDigihapi.png";
import logorounded from "./img/logo-rounded.png";
import logobicolor from "./img/logo-bicolor.png";
import icon from "./img/icon.png";

// Image URLs resolved by webpack (asset modules return the URL string)
export const Images = {
	home,
	maintenance,
	ocamping,
	hapicolibri,
	logo,
	logodigihapi,
	logorounded,
	logobicolor,
	icon
};

export const getImage = name => {
	if (!name) {
		return name;
	}
	return Images[name];
};

export const getImageUri = name => {
	return { uri: Images[name] };
};
